"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _PrimaryButton = _interopRequireDefault(require("./PrimaryButton"));

var _providers = require("../../toolkit/providers");

/* Lego Components */

/* Lego Toolkit */
var PalaceBluePrimaryButton = function PalaceBluePrimaryButton(props) {
  var _useTheme = (0, _providers.useTheme)(),
      secondaryDarker = _useTheme.secondaryDarker;

  return /*#__PURE__*/_react["default"].createElement(_PrimaryButton["default"], (0, _extends2["default"])({}, props, {
    style: {
      backgroundColor: secondaryDarker,
      border: "1px solid ".concat(secondaryDarker)
    }
  }));
};

var _default = PalaceBluePrimaryButton;
exports["default"] = _default;